import React from 'react';
import {withRouter, NavLink} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {TextButton, TextButtonTypes} from '../Buttons';
import LanguageDropdown from './LanguageDropdown';
import styles from './style.css';
import CurrentUser from '../CurrentUser'

const Header = withRouter(inject('store', 'localizationStore')(observer(
  function Header({store, localizationStore}) {
    const onLogoutButtonClick = async () => {
      store.logout().finally(() => {
        window.location.replace('/')
      })
    }
    const locale = localizationStore.locale
    return (
      <div className={styles.header}>
        <div className={styles.userItem}>
          <TextButton style={styles.menuItem} text={locale.logout} type={TextButtonTypes.primary} onClick={onLogoutButtonClick}/>
          <CurrentUser/>
        </div>
        <NavLink activeClassName={styles.selectedNav} to={'/agents'}>{locale.agents}</NavLink>
        {store.userCanSeeKPI() && <NavLink activeClassName={styles.selectedNav} to={'/kpi'}>{locale.KPIs}</NavLink>}
        <LanguageDropdown/>
      </div>
    );
  })))

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js